import utils from '../../services/utils'

export default {
  props: ['data', 'quickShop', 'borders', 'event_id', 'shouldRefetchOnFavorite'],
  methods: {
    openQuickShopModal,
    urlFormatter: utils.urlSafeString,
    handleClick() {
      this.$trackEvent({
        action: 'Brand Profile Click',
        properties: {
          ...this.trackingInfo,
          source: 'Unlabeled non-directory listings'
        }
      })
      this.$router.push(`/brands/${this.data.vanity_url_name}`)
    }
  },
  computed: {
    canShowNynowBadge() {
      return !!this.data?.event_ids?.includes(this.event_id)
    },
    trackingInfo() {
      return { brand_name: this.data?.brand_name }
    }
  }
}

function openQuickShopModal(product) {
  if (this.$session.getAccessToken()) {
    this.$eventBus.$emit('show-quick-shop-modal', product, { eventId: this.event_id })
  } else {
    this.$eventBus.$emit('show-quick-shop-modal-unregistered', product)
    this.$eventBus.$emit('apply-modal-unregistered', product)
  }
}
